/**
 * Checks if the given argument is a number.
 * Examples:
 * isNumber(1); // true
 * isNumber('1'); // false
 * isNumber(NaN); // false
 * @param val
 * @returns
 */
export const isNumber = val => typeof val === 'number' && val === val;
